export const verificationEmail = (state = "",action) => {
    switch(action.type){
        case 'SET_EMAIL':
            return action.payload;
        default:
            return state;
    }
};

export const verificationEmailActions = {
    setEmail: email => ({type: 'SET_EMAIL',payload:{email}})
}

export default verificationEmail;